<template>
  <div>
    <DxPopup
      :visible="this.isVisible"
      :drag-enabled="false"
      :close-on-outside-click="false"
      :show-title="true"
      :show-close-button="false"
      :width="900"
      :height="800"
      :title="title"
    >
      <DxScrollView width="100%" height="100%">
        <div class="textBlock">
          <div class="row">
            <div v-html="markup" />
          </div>
          <div class="row" style="padding-top: 20px">
            <div class="col-md-2">
              <DxButton
                text="Επιστροφή"
                type="danger"
                styling-mode="contained"
                @click="onClosePopup"
              />
            </div>
          </div>
        </div>
      </DxScrollView>
    </DxPopup>
  </div>
</template>


<script>
import { DxButton } from "devextreme-vue/button";
import { DxPopup } from "devextreme-vue/popup";
import { DxScrollView } from "devextreme-vue/scroll-view";

import mainService from "../../services/mainService";

export default {
  props: ["pageName", "isVisible"],
  components: {
    DxButton,
    DxPopup,
    DxScrollView,
  },
  data() {
    return {
      help: null,
      markup: "",
      title: "",
    };
  },
  computed: {},
  methods: {
    onClosePopup(e) {
      this.$emit("emit-close-popup", {});
    },
  },
  async mounted() {
    var initialPageName = this.pageName;
    var pageName = "";
    var _splited = initialPageName.split("/");
    pageName = _splited[1];
    if (_splited.length > 2) {
      pageName += "/";
    }

    const res = await mainService.get(
      `/helpPages/GetHelpPage?pageName=${pageName}`
    );

    this.help = res.data;
    if (res.data != "") {
      this.markup = res.data.HelpText;
      this.title = res.data.Description;
    } else {
      this.markup = "Μή διαθέσιμη Βοήθεια";
      this.title = "Μή διαθέσιμη Βοήθεια";
    }
  },
};
</script>

<style scoped>
.dx-htmleditor-content img {
  vertical-align: middle;
  padding-right: 10px;
}

.dx-htmleditor-content table {
  width: 50%;
}

.options {
  padding: 20px;
  background-color: rgba(191, 191, 191, 0.15);
  margin-top: 20px;
}

.caption {
  font-size: 18px;
  font-weight: 500;
}

.option {
  margin-top: 10px;
}

.textBlock {
  padding-left: 20px;
  padding-right: 20px;
  line-height: 1.6em;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-top: 20px;
  width: 300px;
}
</style>